import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';

interface VideoFieldProps extends FormlyFieldProps {
  src: string;
}

@Component({
  selector: 'app-video-field',
  imports: [ReactiveFormsModule, FormlyModule, SelectModule, TextareaModule],
  templateUrl: './video-field.component.html',
  styleUrl: './video-field.component.scss',
})
export class VideoFieldComponent extends FieldType<
  FieldTypeConfig<VideoFieldProps>
> {}
